import { render, staticRenderFns } from "./class.vue?vue&type=template&id=60034522&scoped=true"
import script from "./class.vue?vue&type=script&lang=js"
export * from "./class.vue?vue&type=script&lang=js"
import style0 from "./class.vue?vue&type=style&index=0&id=60034522&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60034522",
  null
  
)

export default component.exports